<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> Medida de contingencia {{data.medida}}<span *ngIf="action == 'Delete'">?</span></h1>
<div mat-dialog-content>

  <div class="content p-24" fxLayout="column">

    <div fxLayout="row" xFlex="100" *ngIf="action!='Delete'">

        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="100">

            <div class="profile-box info-box general" fxLayout="column">

              <table class="summary">
                  <tr>
                      <td class="label">Riesgo</td>
                      <td class="value">
                        <mat-form-field fxFlex>
                          <mat-label>Riesgo</mat-label>
                          <mat-select [(ngModel)]="data.riesgo" class="roleSelect"
                              [compareWith]="compareObjects"
                              [disabled]="action=='View' || action=='Delete'">
                              <mat-option *ngFor="let riesgo of riesgos" [value]="riesgo">
                                  {{riesgo.nombre}}
                              </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>
                  </tr>

                  <tr>
                      <td class="label">Medida</td>
                      <td class="value">
                        <div id="register-form" fxLayout="column">

                            <div fxLayout="column">

                              <div fxFlex>
                                <mat-form-field  fxFlex>
                                  <input placeholder="Medida" matInput [(ngModel)]="data.medida" fxFlex [disabled]="action=='View' || action=='Delete'">
                                </mat-form-field>
                              </div>
                            </div>
                        </div>

                      </td>
                  </tr>

                  <tr>
                    <td class="label">Estructura Jerárquica</td>
                    <td class="value">
                        <span *ngIf="data.estructura!=null" fxFlex>{{data.estructura?.nombre}} / {{data.nodo?.nombre}}</span>
                        <button mat-button mat-raised-button (click)="openDialog()" [disabled]="action=='View' || action=='Delete'">Seleccionar nodo</button>
                    </td>
                  </tr>

                  <tr>
                      <td class="label">Referente</td>
                      <td class="value">
                        <mat-form-field fxFlex>
                          <mat-label>Referente</mat-label>
                          <mat-select
                          [(ngModel)]="data.referente"
                          [compareWith]="compareObjects"
                          [disabled]="action=='View' || action=='Delete'"
                          class="roleSelect">
                              <mat-option *ngFor="let usuario of data.nodo?.usuarios" [value]="usuario">
                                  {{usuario.nombreCompleto}}
                              </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>
                  </tr>

                  <tr>
                      <td class="label">Responsable</td>
                      <td class="value">
                        <input placeholder="Responsable" matInput [(ngModel)]="data.responsable" fxFlex [disabled]="action=='View' || action=='Delete'">
                      </td>
                  </tr>

              </table>
            </div>
        </div>
    </div>
<!--
      <div fxLayout="row" xFlex="100">

          <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="100">

              <div class="profile-box info-box general" fxLayout="column">

                <table class="summary">
                  <tr>
                      <td class="label">Estructura Jerárquica</td>
                      <td class="value">
                          <span *ngIf="data.estructura!=null" fxFlex>{{data.estructura?.nombre}} / {{data.nodo?.nombre}}</span>
                          <button mat-button mat-raised-button (click)="openDialog()">Seleccionar nodo</button>
                      </td>
                  </tr>

                </table>
              </div>
          </div>

          <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="50">
            <div class="profile-box info-box general" fxLayout="column">
              <table class="summary">

                <tr>
                    <td class="label">Referente</td>
                    <td class="value">
                      <mat-form-field fxFlex>
                        <mat-label>Referente</mat-label>
                        <mat-select
                        [(ngModel)]="data.referente"
                        [compareWith]="compareObjects"
                        class="roleSelect">
                            <mat-option *ngFor="let usuario of data.nodo?.usuarios" [value]="usuario">
                                {{usuario.nombreCompleto}}
                            </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                </tr>

                <tr>
                    <td class="label">Responsable</td>
                    <td class="value">
                      <input placeholder="Responsable" matInput [(ngModel)]="data.responsable" fxFlex>
                    </td>
                </tr>

              </table>
          </div>
      </div>
    </div>
-->

  </div>

</div>
<div mat-dialog-actions>
  <button mat-button *ngIf="action=='Delete'" (click)="doAction()" >Eliminar</button>
  <button mat-button *ngIf="action!='Delete' && action!='View'" (click)="doAction()" [disabled]="data.estructura ==null || data.medida=='' || data.riesgo==null || data.referente==null || data.responsable==null">Guardar</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">Cancelar</button>
</div>
